import { render, staticRenderFns } from "./gasClamp_up.vue?vue&type=template&id=1248795a&scoped=true"
import script from "./gasClamp_up.vue?vue&type=script&lang=js"
export * from "./gasClamp_up.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_up.vue?vue&type=style&index=0&id=1248795a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1248795a",
  null
  
)

export default component.exports